import ShareReferral from '@/interfaces/referral.interface'
import Share from '@/interfaces/share-links.interface'
import onEnvironmentChange from '@/observables/environment.observable'
import type Environment from '@interfaces/environment.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import type { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class MrFantasticService extends MainService {
  url: string
  logService = new LogService()

  constructor(mrFantasticUrl?: string) {
    super()
    if (!mrFantasticUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.mrFantastic
      })
    } else {
      this.url = mrFantasticUrl
    }
    this.logService.init('Hub Mr Fantastic Service')
  }

  public async getShare(payload: ShareReferral): Promise<Share> {
    const headers = await this.getHeaders()
    return this.http
      .post(`${this.url}/hub/share`, payload, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get share lisks ',
          error,
        })
        throw error.response
      })
  }
}
